import React from 'react';

const TextContent = ({ type }) => {
  if (type === 'contractor') {
    return (
      <p style={{ fontSize: 17 }}>
        Please Review the contract. <br />
        You won't be able to edit it once you sign it.
      </p>
    );
  }
  return (
    <p style={{ fontSize: 17 }}>
        Please Review the contract. <br />
    </p>
  );
};

export default TextContent;



// WEBPACK FOOTER //
// ./src/routes/contract-sign/ContractPDF/TextContent/index.js